import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/authSlice';
import technicianReducer from '../features/technicianSlice';
import dashboardReducer from '../features/dashboardSlice';

export default configureStore({
  reducer: {
    auth: authReducer,
    technicians: technicianReducer,
    dashboard: dashboardReducer,
  },
});
